module.exports = __webpack_public_path__ + "static/me-4cc41fcdaca95d8781eb6f7bcf666889.jpg";